import { useNavigate } from "react-router-dom";
import { BigTableIcon, HostSmallTableIcon, JoinSmallTableIcon } from "@/components/MedievalIcons";
import TopBar from "@/components/TopBar";
import NavPane from "@/components/NavPane";

const TavernHall = () => {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen overflow-x-clip flex flex-col" data-testid="tavern-hall-page">
      <div className="absolute inset-0 tapestry-grid pointer-events-none opacity-50" />
      <TopBar
        theme="tavern"
        onBack={() => navigate("/")}
        backLabel="Menu"
        testId="tavern-back-button"
      />
      <div className="relative z-10 max-w-7xl w-full mx-auto flex flex-col md:flex-row flex-1">
        <div
          className="md:w-[260px] md:shrink-0 md:min-h-screen flex flex-col pt-4 md:pt-6 px-4 md:px-6 pb-6 md:border-r"
          style={{ borderColor: "rgba(229,200,112,0.18)" }}
        >
          <NavPane theme="tavern" />
        </div>
        <div className="flex-1 px-4 md:px-8 pt-6 pb-12">
        <div className="text-center mb-8">
          <h1
            className="font-display text-4xl md:text-5xl font-bold tracking-tight"
            style={{ color: "#E5C870", textShadow: "0 1px 0 rgba(0,0,0,0.7), 0 0 18px rgba(201,162,74,0.5)" }}
          >
            The Tavern
          </h1>
        </div>

        <p className="text-center text-amber-100/85 italic font-body text-base mb-8">
          Where shall thy seat be? The hearth is warm — choose thy table.
        </p>

        {/* ===== Rules of the Local Tavern — moved here from the
             homepage in iter 51 and re-tinted to match the Tavern's
             parchment-on-dark-wood aesthetic. */}
        <section
          className="arcade-panel max-w-2xl mx-auto p-5 mb-10"
          data-testid="tavern-rules-canvas"
        >
          <div
            className="font-gothic text-2xl text-center mb-3 tracking-wide"
            style={{ color: "#7A1F1F" }}
            data-testid="tavern-rules-title"
          >
            Rules of the Local Tavern
          </div>
          <ol
            className="list-decimal pl-6 space-y-2 text-base"
            style={{
              color: "#3A2A18",
              lineHeight: 1.7,
              fontFamily: "'IM Fell English', 'IM Fell DW Pica', 'IM Fell', Garamond, 'EB Garamond', serif",
              fontWeight: 700,
              fontStyle: "normal",
            }}
          >
            <li>Be kind and respectful.</li>
            <li>No trolling, spamming, or shitposting.</li>
          </ol>
        </section>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <button
            onClick={() => navigate("/tavern/big")}
            className="arcade-panel p-3 flex flex-col items-center gap-1 hover:bg-amber-100/40 transition-colors group"
            data-testid="big-table-button"
          >
            <BigTableIcon size={56} className="text-amber-700 group-hover:scale-110 transition-transform" />
            <div className="font-gothic text-3xl whitespace-nowrap leading-tight tracking-wide text-center" style={{ color: "#7A1F1F" }}>
              Sit at the Big Table
            </div>
            <div className="text-xs italic text-stone-700 font-body text-center">
              Public hearth — every patron may speak with every other.
            </div>
          </button>

          <button
            onClick={() => navigate("/tavern/host")}
            className="arcade-panel p-3 flex flex-col items-center gap-1 hover:bg-amber-100/40 transition-colors group"
            data-testid="host-small-table-button"
          >
            <HostSmallTableIcon size={56} className="text-amber-700 group-hover:scale-110 transition-transform" />
            <div className="font-gothic text-3xl whitespace-nowrap leading-tight tracking-wide text-center" style={{ color: "#7A1F1F" }}>
              Host at a Small Table
            </div>
            <div className="text-xs italic text-stone-700 font-body text-center">
              Open a private corner — share thy chamber-key with chosen friends.
            </div>
          </button>

          <button
            onClick={() => navigate("/tavern/join")}
            className="arcade-panel p-3 flex flex-col items-center gap-1 hover:bg-amber-100/40 transition-colors group"
            data-testid="join-small-table-button"
          >
            <JoinSmallTableIcon size={56} className="text-amber-700 group-hover:scale-110 transition-transform" />
            <div className="font-gothic text-3xl whitespace-nowrap leading-tight tracking-wide text-center" style={{ color: "#7A1F1F" }}>
              Join at a Small Table
            </div>
            <div className="text-xs italic text-stone-700 font-body text-center">
              Pick from the small tables already in session, or enter a chamber-key.
            </div>
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default TavernHall;
